import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

const NORMAS = [
    "ISO 9001:2015",
    "ISO 17020:2012",
    "ISO 45001:2018",
    "ISO 14001:2015",
    "ISO 19011:2018",
    "RETIE / RETILAP",
];

export default function OrderNew() {
    const nav = useNavigate();
    const [clients, setClients] = useState([]);
    const [techs, setTechs] = useState([]);
    const [form, setForm] = useState({
        client_id: "", technician_cedula: "", sistema_a_revisar: "",
        norma_iso: "ISO 9001:2015", fecha_programada: new Date().toISOString().slice(0, 10),
        direccion: "", telefono_encargado: "", encargado_nombre: "", email_informe: "",
    });
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        (async () => {
            const [c, t] = await Promise.all([api.get("/clients"), api.get("/technicians")]);
            setClients(c.data); setTechs(t.data.filter(x => x.activo));
        })();
    }, []);

    const onClient = (cid) => {
        const c = clients.find(x => x.client_id === cid);
        setForm(f => ({
            ...f, client_id: cid,
            direccion: c?.direccion || "",
            telefono_encargado: c?.telefono || "",
            encargado_nombre: c?.encargado_nombre || "",
            email_informe: c?.email || "",
        }));
    };

    const submit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            const payload = { ...form, fecha_programada: new Date(form.fecha_programada).toISOString() };
            const r = await api.post("/orders", payload);
            nav(`/orders/${r.data.order_id}`);
        } catch (err) {
            alert(err.response?.data?.detail || "Error");
            setSubmitting(false);
        }
    };

    return (
        <div className="max-w-3xl mx-auto p-4 md:p-8" data-testid="order-new-page">
            <div className="mb-8 border-b border-zinc-200 pb-6">
                <div className="overline mb-2">Área comercial</div>
                <h1 className="font-display text-4xl font-black tracking-tighter">Crear orden de servicio</h1>
                <p className="text-sm text-zinc-600 mt-2">Asigna a un técnico activo. El técnico solo podrá iniciar la inspección si valida su cédula al llegar al sitio.</p>
            </div>

            <form onSubmit={submit} className="space-y-6" data-testid="new-order-form">
                <Field label="Cliente *">
                    <select className="input-atia" value={form.client_id} onChange={e => onClient(e.target.value)} required data-testid="order-client">
                        <option value="">— Selecciona cliente —</option>
                        {clients.map(c => <option key={c.client_id} value={c.client_id}>{c.razon_social} · {c.nit}</option>)}
                    </select>
                </Field>

                <Field label="Técnico asignado * (debe coincidir CC al iniciar visita)">
                    <select className="input-atia" value={form.technician_cedula} onChange={e => setForm({...form, technician_cedula: e.target.value})} required data-testid="order-tech">
                        <option value="">— Selecciona técnico —</option>
                        {techs.map(t => <option key={t.tech_id} value={t.cedula}>{t.nombre} · CC {t.cedula} {t.especialidad ? `· ${t.especialidad}` : ""}</option>)}
                    </select>
                </Field>

                <Field label="Sistema a revisar *">
                    <input className="input-atia" value={form.sistema_a_revisar} required onChange={e => setForm({...form, sistema_a_revisar: e.target.value})} data-testid="order-sistema" placeholder="Ej: Tablero principal eléctrico, HVAC, Estructura cubierta…" />
                </Field>

                <div className="grid sm:grid-cols-2 gap-4">
                    <Field label="Norma aplicable *">
                        <select className="input-atia" value={form.norma_iso} onChange={e => setForm({...form, norma_iso: e.target.value})} required data-testid="order-norma">
                            {NORMAS.map(n => <option key={n}>{n}</option>)}
                        </select>
                    </Field>
                    <Field label="Fecha programada *">
                        <input type="date" className="input-atia" value={form.fecha_programada} onChange={e => setForm({...form, fecha_programada: e.target.value})} required data-testid="order-fecha" />
                    </Field>
                </div>

                <div className="overline pt-3 border-t border-zinc-200">Datos del contacto en sitio (heredados del cliente, editables)</div>
                <div className="grid sm:grid-cols-2 gap-4">
                    <Field label="Encargado">
                        <input className="input-atia" value={form.encargado_nombre} onChange={e => setForm({...form, encargado_nombre: e.target.value})} data-testid="order-enc" />
                    </Field>
                    <Field label="Teléfono encargado">
                        <input className="input-atia" value={form.telefono_encargado} onChange={e => setForm({...form, telefono_encargado: e.target.value})} data-testid="order-tel" />
                    </Field>
                </div>
                <Field label="Dirección del servicio">
                    <input className="input-atia" value={form.direccion} onChange={e => setForm({...form, direccion: e.target.value})} data-testid="order-dir" />
                </Field>
                <Field label="Email para envío del informe *">
                    <input type="email" className="input-atia" value={form.email_informe} onChange={e => setForm({...form, email_informe: e.target.value})} required data-testid="order-mail" />
                </Field>

                <div className="flex gap-3 pt-4 border-t border-zinc-200">
                    <button type="submit" disabled={submitting} className="btn-accent flex-1" data-testid="submit-order">
                        {submitting ? "Creando…" : "Crear orden de servicio →"}
                    </button>
                    <button type="button" onClick={() => nav(-1)} className="btn-secondary" data-testid="cancel-order">Cancelar</button>
                </div>
            </form>
        </div>
    );
}

function Field({ label, children }) {
    return (
        <label className="block">
            <div className="overline mb-2">{label}</div>
            {children}
        </label>
    );
}
